import { useState } from "react";
import { Plus } from "lucide-react";

const inputCls = "h-7 px-2 rounded-sm bg-slate-950 border border-slate-800 text-[12px] text-slate-100 focus:outline-none focus:border-amber-400";

export function AddRowForm({ rooms, onAdd, busy }) {
  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [room, setRoom] = useState(rooms[0] || "");

  const submit = async (e) => {
    e.preventDefault();
    if (!first.trim() && !last.trim()) return;
    const ok = await onAdd({ first: first.trim(), last: last.trim(), room });
    if (ok) { setFirst(""); setLast(""); }
  };

  return (
    <form onSubmit={submit} className="flex items-center gap-2 px-3 py-2.5 border-t border-dashed border-slate-700 bg-slate-900/40" data-testid="numbers-add-row-form">
      <span className="text-[10px] uppercase tracking-widest font-bold text-slate-500 shrink-0">Add missed row</span>
      <input value={first} onChange={(e) => setFirst(e.target.value)} placeholder="First name" className={`${inputCls} w-28`} data-testid="numbers-add-first" />
      <input value={last} onChange={(e) => setLast(e.target.value)} placeholder="Last name" className={`${inputCls} w-28`} data-testid="numbers-add-last" />
      <select value={room} onChange={(e) => setRoom(e.target.value)} className={`${inputCls} w-36`} data-testid="numbers-add-room">
        {rooms.map((r) => <option key={r} value={r}>{r}</option>)}
      </select>
      <button type="submit" disabled={busy || (!first.trim() && !last.trim())} data-testid="numbers-add-row-btn"
        className="h-7 px-3 inline-flex items-center gap-1 rounded-sm bg-slate-100 text-slate-950 text-[10px] font-bold uppercase tracking-widest hover:bg-white disabled:opacity-40">
        <Plus className="h-3 w-3" />Add
      </button>
    </form>
  );
}
